import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux'
import { createStore, combineReducers } from 'redux'
import {
  ReactReduxFirebaseProvider,
  firebaseReducer
} from 'react-redux-firebase'
import { createFirestoreInstance, firestoreReducer } from 'redux-firestore';

import firebase from 'firebase/app'

import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database'
import 'firebase/storage';
import 'firebase/functions';

const fbConfig = {
  apiKey: "AIzaSyBtYvW-M7K0fqbtHO22Pne28jIUkpYEGWM",
  authDomain: "narratedbypoise.firebaseapp.com",
  databaseURL: "https://narratedbypoise.firebaseio.com",
  projectId: "narratedbypoise",
  storageBucket: "narratedbypoise.appspot.com",
  messagingSenderId: "93968084900",
  appId: "1:93968084900:web:ca114eebd6b3116f615b31",
  measurementId: "G-S6QH7P4PHR"
}

// react-redux-firebase config
const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
}

// Initialize firebase instance
firebase.initializeApp(fbConfig)

if (process.env.REACT_APP_FIREBASE_EMULATOR === 'yes') {
  console.log("testing locally -- hitting local functions and firestore emulators");
  firebase.functions().useFunctionsEmulator('http://localhost:5001');
  firebase.firestore().settings({
    host: 'localhost:8080',
    ssl: false
  });
  firebase.auth().useEmulator('http://localhost:9099/');
}


// Initialize other services on firebase instance
firebase.firestore() // <- needed if using firestore

// Add firebase to reducers
const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer
})

// Create store with reducers and initial state
const initialState = {}
const store = createStore(
  rootReducer,
  initialState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <App />
      </ReactReduxFirebaseProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
